
import { NotDisturbModeScreenNavigationProps } from "./types"
import React from "react"
import NotDisturbMode from "./not-disturb-mode-screen"
import { PageRoot } from "~screens/page-root"


// 免打扰模式
const NotDisturbModeScreen: React.FC<NotDisturbModeScreenNavigationProps> = ({ route }) => {
  return (
    <PageRoot>
      <NotDisturbMode route={route}/>
    </PageRoot>
  )
}

export default NotDisturbModeScreen
